/** UUID with a fallback for non-secure origins, where `randomUUID` is absent. */
export function createId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

/** Short, human-scannable form for showing a conversation id in the UI. */
export function shortId(value: string, length = 8): string {
  return value.replace(/-/g, '').slice(0, length)
}
